import { useState } from "react";
import { MAX_BASE, TAX_RATE, Euro, eur, fmt, Toggle, Field, Note, InputCard, ResultCard } from "./shared";
import { useLang } from "@/lib/i18n";

const EMPLOYEE_RATE = 0.1378;
const EMPLOYER_RATE = 0.1892;

const fromGross = (gross) => {
  const base = Math.min(gross, MAX_BASE);
  const empIns = base * EMPLOYEE_RATE;
  const tax = (gross - empIns) * TAX_RATE;
  const erIns = base * EMPLOYER_RATE;
  return { gross, empIns, tax, net: gross - empIns - tax, erIns, total: gross + erIns };
};

const fromNet = (net) => {
  let lo = net;
  let hi = net * 2 + 1;
  for (let i = 0; i < 60; i++) {
    const mid = (lo + hi) / 2;
    if (fromGross(mid).net < net) lo = mid;
    else hi = mid;
  }
  return fromGross((lo + hi) / 2);
};

export const SalaryCalc = () => {
  const [mode, setMode] = useState("gross");
  const [amount, setAmount] = useState("1500");
  const { t } = useLang();
  const s = t.calc.salary;
  const num = parseFloat(amount.replace(",", ".")) || 0;
  const r = mode === "gross" ? fromGross(num) : fromNet(num);

  const rows = [
    { label: s.rows.emp, ...eur(r.empIns), testid: "calc-row-emp-insurance" },
    { label: s.rows.tax, ...eur(r.tax), testid: "calc-row-tax" },
    { label: s.rows.er, ...eur(r.erIns), testid: "calc-row-er-insurance" },
    { label: s.rows.total, ...eur(r.total), testid: "calc-row-total-cost" },
    { label: s.rows.gross, ...eur(r.gross), testid: "calc-row-gross" },
  ];
  const mainVal = mode === "gross" ? r.net : r.gross;

  return (
    <>
      <InputCard kicker={s.kicker}>
        <Toggle
          testidPrefix="calc-mode"
          value={mode}
          onChange={setMode}
          options={[
            { id: "gross", label: s.gross2net },
            { id: "net", label: s.net2gross },
          ]}
        />
        <Field id="calc-amount" testid="calc-amount-input" label={mode === "gross" ? s.grossLabel : s.netLabel} value={amount} onChange={setAmount} />
        <Note>{s.notePrefix}{s.note}{s.noteSuffix}</Note>
      </InputCard>
      <ResultCard
        title={s.title}
        service={s.service}
        note={s.note}
        label={mode === "gross" ? s.resultNet : s.resultGross}
        main={<Euro value={mainVal} />}
        mainText={`${fmt(mainVal)} €`}
        rows={rows}
      />
    </>
  );
};
